import axios from 'axios';
import { exportBlockedInDemoMode } from '@/utils/demoSpoof';

export async function downloadFrame(frame) {
  if (exportBlockedInDemoMode()) return null;
  try {
    const { data } = await axios.get(`api/impact_analytics/frames/${frame.id}/download/`, { responseType: 'blob' });
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${String(frame.name || 'frame').replace(/[^a-z0-9]+/gi, '_')}_${frame.id}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    return null;
  } catch (err) {
    return err?.response?.status === 403 ? 'Downloading rows needs PHI access.' : 'The download failed.';
  }
}
